import React, { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { Header } from "../../components/header/header";
import { PageSupport } from "../../components/utilities/page-support";

import "../../styles/village.css";
import { days, villageData } from "../../_helpers/village-data";
import { bgColors } from "../../_helpers/mock";
import { SharpPoly } from "../../components/containers/sharp-polygon";
import { Zoomer, SquareY, SquareZ, Square } from "../../components/cards/framer-motion";
import { FlipAnim, Stretch } from "../../components/cards/anims";


export const MbeiVillage = () => {

    const [viewed, setViewed] = useState(0);

    const toggleView = (k) => {
        viewed === k ? setViewed() : setViewed(k);
    }

    const animArray = [Zoomer, SquareY, SquareZ, Stretch, FlipAnim, Square];

    function DynamicElement({ tagName, content, ...props }) {
        return React.createElement(tagName, null, content);
    }


    return (
        <div className={classNames("f-pg", 'vil')}>
            <PageSupport />
            <Header pageTitle={"Mbei Fondom"} />
            <Zoomer>
                <div className={classNames("pg-cap", 'cap-unit')}>THE MBEI FONDOM</div>
            </Zoomer>
            <SquareY>
                <div className="sub-cap">INTRODUCTION</div>
            </SquareY>
            <p className="v-p">
                Mbei, a fondom nestled in the Santa sub division of the North-West region of Bamenda, Cameroon. Rulled by a second class Fon (Mokom Njei III), this village boasts a captivating indigenous culture that is deeply rooted in its agricultural lifestyle.
            </p>
            <div className="int-img-container">
                <img className="int-img" src="/images/fon-of-mbei.png" alt="" />
                <div className="int-img-lbl">HRH Fon Mokom Njei III (foreground), Fon of Mbei.</div>
            </div>
            <div className="v-p">
                The hardworking and hospitable people of Mbei predominantly engage in farming activities, cultivating a diverse range of crops such as potatoes, vegetables, spices, and rearing animals.
            </div>
            <div className="v-p">
                The inhabitants of Mbei fondom take immense pride in their rich and unique cultural heritage, which is reflected in their customs, traditions, and festivities. Traditional dances, colorful attire, and captivating music are integral to their cultural expression. The Mbei people hold a strong sense of community, fostering unity and cooperation among its members, with a predominantly vibrant youth community and a solid Elite/diaporan core.
            </div>
            <div className="v-p">
                The culinary delights of Mbei are a true reflection of their cultural identity. The village is renowned for its variety of dishes, which showcase the abundance of locally grown produce. From hearty stews infused with aromatic spices to mouthwatering delicacies prepared from fresh vegetables, Achu, pounded potatoes and beans (futoh chuteh) are amongst the delicacies of the table. Mbei's cuisine tantalizes the taste buds and offers a glimpse into their deep connection with the land.
            </div>
            <div className="v-p">
                In briefs, Mbei's indigenous culture is a tapestry woven with hard work, hospitality, vibrant traditions, and delectable cuisine. The villagers' unyielding dedication to their farming traditions, coupled with their warm-heartedness, make Mbei an extraordinary place that celebrates the beauty of the grassfields of Cameroonian culture.
            </div>
            <div className="v-p">
                The Mbei village comprises thirteen (13) quarters, each being overseen by a quarter head and his counsellors. These quarters include:
            </div>
            {villageData.map((data, k) => (
                <Zoomer key={k}>
                    <div className="quarters">
                        <div
                            className={classNames("dev-unit", 'vil-drp')}
                            onClick={() => toggleView(k)}
                            style={{ backgroundColor: bgColors[k % 7] }}
                        >
                            <div className={classNames("dev-unit-text", 'vil-cap')} >{data.quarter}</div>
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className={classNames("dev-unit-text", { 'fold-chev': viewed === k }, 'norm-chev')}
                            />
                        </div>
                        <div className={classNames('comm-det', { 'seen-quart': viewed === k })} >
                            <div
                                dangerouslySetInnerHTML={{ __html: data.info }}
                                className="flx-c-col"
                            />

                            <img className="int-img" src={data.image} alt="" />
                            <div className="int-img-lbl">{data.quarter}</div>

                        </div>
                    </div>
                </Zoomer>
            ))}
            <Stretch>
                <div className={classNames("flx-c")}>
                    <div className="rw-elem">
                        <SharpPoly text={"Culture and Tradition"} bgColor={"#322332"} />
                    </div>
                </div>
            </Stretch>
            <p className="v-p">
                The Mbei people speak the variant of the MOGHAMO dialect, which is also spoken by people of BANJAH, NGIEN-MBOU, BABA II, MEFORBE and BAFORCHU.
            </p>
            <p className="v-p">
                Every quarter in the Mbei village is headed by a quarter head, who answers to, and is a member the Mbei vilage council. The Mbei village council is subordinate to the traditional council are, which is headed by HRH. the Fon of Mbei. The vilage council is mostly responsible for administrative side of the village and is responsible for overseeing issues concerning the welfare of the occupants of the village and development projects in the village.
            </p>
            <p className="v-p">
                The Traditional council known in the dialect as the 'Quihfon' is the sacred arm of the village which is responsible for enforcing the laws of the land, making sure that the village exists in tune with the spiritual norms laid down across generations by its founding fathers.
            </p>
            <div className="v-p">
                The village still observes a traditional eight-day week, with days as follows in their order:
                <div className="day-container">
                    {days.map((day, k) => (
                        <DynamicElement tagName={animArray[k % 3]} content={
                             <div
                                className={classNames("day-label", 'flx-c', { 'hol': k === 5 })}
                                key={k}
                                style={{ backgroundColor: bgColors[(k + 2) % 7], color: "#fff" }}
                            >
                                {day}
                            </div>
                        } />
                           
                        
                    ))}
                </div>
            </div>
            <p className="v-p">
                Each of the above days has a rich historical and cultural significance. As of 2025 the day Kuoh is known as a traditional resting day or 'Nigh pfue'. On this day, it is forbidden to do any farming or construction works.
            </p>
        </div>
    );
}